import { F_Fammily, Font } from "../../../../util/config-fonts";
import { KEY_GENERATOR } from "../../../../functions/funtion";
import { Colors } from "../../../../util/colors";

function PgProductUom({
  Heading = String,
  data = Object,
  SectedButton = Number,
  OnClick = () => { },
}) {

  return (
    <div
      style={{
        display: data.length > 1 ? "block" : "none",
      }}
      className="pgProductDesc"
    >
      <p style={{ fontFamily: F_Fammily.Medium, margin: 0 }}>{Heading}</p>
      {data.map((rs, i) => {
        return (
          <div style={{ display: "flex", padding: 5 }} key={KEY_GENERATOR()}>
            <input
              type="radio"
              value={rs.USeqID}
              name="Uom"
              onClick={(e) => {
                OnClick(e, rs, i);
              }}
              defaultChecked={SectedButton === i + 1 ? true : false}
              style={{
                marginRight: 5,
                fontSize: Font.Heading,
                color: Colors.ThemeBGcolor,
                accentColor: Colors.ThemeBGcolor,
                cursor: "pointer",
              }}
            />

            <p
              style={{
                fontSize: Font.Description,
                margin: 0,
                paddingTop: 3,
              }}
              onClick={(e) => {
                OnClick(e, rs, i);
              }}
            >
              {rs.UOM}
            </p>
          </div>
        );
      })}
    </div>
  );
}
export default PgProductUom;
